import type { RouteRecordRaw } from 'vue-router';

export const mcpTokensRoute: RouteRecordRaw = {
  path: '/me/mcp-tokens',
  name: 'McpTokens',
  component: () => import('./pages/McpTokensPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:mcp-tokens:list'),
  },
};

// Згода на вхід клієнта MCP (claude.ai, Claude Desktop) через OAuth. Не
// публічна: без сесії auth-мідлвара веде на вхід і повертає сюди — тому id
// запиту в шляху, а не в рядку запиту.
export const oauthConsentRoute: RouteRecordRaw = {
  path: '/oauth/consent/:requestId',
  name: 'OauthConsent',
  component: () => import('./pages/OauthConsentPage.vue'),
  props: (route) => ({ requestId: String(route.params['requestId']) }),
  meta: {
    layout: 'empty',
  },
};
